(ns nosco.ui.ai.placement
  "Admin-only floating chat placement shared with generic modal layers."
  (:require ["react" :as React]))

(def AdminFloatingContext (React/createContext nil))
